import attachBlockListeners from './block';
import attachComponentListeners from './component';
import attachEditorListeners from './editor';
import attachKeymapListeners from './keymaps';
import attachSelectionListeners from './selection';
import attachStorageListeners from './storage';
import attachStyleListeners from './style';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';

/**
 * Initialize listeners for the editor
 * @param opt The grapesjs config object
 */
export default (opt: PrimaryConfigOptions): void => {
  attachBlockListeners(opt);
  attachComponentListeners(opt);
  attachEditorListeners(opt);
  attachKeymapListeners(opt);
  attachSelectionListeners(opt);
  attachStorageListeners(opt);
  attachStyleListeners(opt);
};